import useMutation from "src/hooks/useMutation";

function useWarehouseTransferStatusIn(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/status-in`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseTransferStatusIn;
